import React from "react";

const Content = ({ children }) => (
  <div className="contenedorConfig">{children}</div>
);

export default Content;
